(function(){
  function init(gal){
    var track = gal.querySelector('[data-gal-track]');
    if(!track) return;
    var dots = gal.querySelectorAll('.gal-dot');
    var thumbs = gal.querySelectorAll('.gal-thumb');
    var slides = track.querySelectorAll('.gal-slide');

    gal.querySelectorAll('[data-gal-go]').forEach(function(b){
      b.addEventListener('click', function(){
        var i = parseInt(b.getAttribute('data-gal-go'), 10);
        if(slides[i]) track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });

    function mark(){
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      i = Math.max(0, Math.min(slides.length - 1, i));
      for(var n=0;n<dots.length;n++) dots[n].classList.toggle('on', n===i);
      for(var n=0;n<thumbs.length;n++) thumbs[n].classList.toggle('on', n===i);
    }
    var t;
    track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
    mark();
  }
  function boot(){ document.querySelectorAll('[data-gal]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
